import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { AuthContextProvider } from './contexts/AuthContext';
import { CartContextProvider } from './contexts/CartContext';
import { ThemeContextProvider } from './contexts/ThemeContext';
import { TransactionContextProvider } from './contexts/TransactionContext';
import { LandingBusinessContextProvider } from './contexts/LandingBusinessContext';
import { ApiProvider } from './server/api';
import Routes from './routes';
import { RatingContextProvider } from './contexts/RatingContext';
import { PointsContextProvider } from './contexts/PointsContext';
import { KPIContextProvider } from './contexts/KPIContext';

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <AuthContextProvider>
          <ApiProvider>
            <ThemeContextProvider>
              <PointsContextProvider>
                <CartContextProvider>
                  <TransactionContextProvider>
                    <LandingBusinessContextProvider>
                      <RatingContextProvider>
                        <KPIContextProvider>
                          <ToastContainer />
                          <Routes />
                        </KPIContextProvider>
                      </RatingContextProvider>
                    </LandingBusinessContextProvider>
                  </TransactionContextProvider>
                </CartContextProvider>
              </PointsContextProvider>
            </ThemeContextProvider>
          </ApiProvider>
        </AuthContextProvider>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
